const SvgSkillCheck=()=>{
return(
<>
<svg
                        width="21"
                        height="11"
                        viewBox="0 0 21 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="inline-block mr-1"
                      >
                        <path
                          d="M4.66669 11L14 1.57143L12.4444 0L4.66665 7.85719L1.55555 4.71434L0 6.28577L4.66669 11Z"
                          fill="#63BD43"
                        />
                       
                      </svg>
</>

);

};
export default SvgSkillCheck;